import { useEffect } from 'react';
import HeaderOnlyWhite from '../components/HeaderOnlyWhite'
import Footer from '../components/Footer';
import RightPanelMobile from '../components/RightPanelMobileToIns.jsx';

function ContactUs() {

  useEffect(() =>
  {
    window.CallDefaultFunction("ContactUs");
  }, []);

  return (
    <>
      
      <div className="basic">

        <HeaderOnlyWhite/>

        <div className="MainContentSection">
          <div className="MainSectionWithoutAnyAdd IgnoreWPercent" style={{maxWidth: 'none'}}>
            <div className="BlueTopBigContainer">
              <p className="PaymentSectionHeaderText2 InterBoldTextFont" id="ContactUsHeaderText">Contact Us</p>
              <p className="LabelGreyHeaderText InterMediumTextFont" id="ContactUsMessageText">Collaborate for Success: Get in Touch Now</p>
            </div>
          </div>
          <div className="BasicContainerExtraSec BasicBoxShadow BasicRadius MinusMarginDueToBlue ContactUsDoubleWrapper">
            <div className="ContactUsSectionSeparator">
              <div className="BasicContainerPadding">
                <div className="InputFieldMargin2 TopContactUsTextandImg">
                  <p className="SectionHeaderTextIndex InterMediumTextFont" style={{marginLeft: 0, width: 'fit-content'}} id="SendUsAMessageHeaderText">Send us a Message</p>
                  <img src="/Assets/images/ButtonIcon/message-icon-blue.svg" alt="" />
                </div>
                <div className="BasicRadius MarginTextUpDown RedWarningContainer" id="RedSendErrorContainer" style={{marginTop: '0px', display: 'none'}}>
                  <p className="InterMediumTextFont" id="RedSendErrorText">Format Email Tidak Valid!</p>
                </div>
                <div className="TwoSeparatorWrapper InputFieldMargin">
                  <div className="TwoSeparatorContent">
                    <p className="InputFieldHeaderText InterMediumTextFont" id="ContactUsYourNameHeaderText">Your Name</p>
                    <div className="SmallPanelDropDownContainer BasicInputFieldContainer Selectable3" style={{width: '100%', minWidth: '100%'}} id="ContactUsYourNameInputContainer">
                      <input type="text" name="YourName" className="InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont" placeholder="David Bayu" id="ContactUsYourNameInputField" />
                    </div>
                    <p className="RedWarningText InterMediumTextFont RedWarningHidden" id="ContactUsYourNameWarning">Sample Warning</p>
                  </div>
                  <div className="TwoSeparatorContent">
                    <p className="InputFieldHeaderText InterMediumTextFont" id="ContactUsCompanyHeaderText">Company</p>
                    <div className="SmallPanelDropDownContainer BasicInputFieldContainer Selectable3" style={{width: '100%', minWidth: '100%'}} id="ContactUsCompanyInputContainer">
                      <input type="text" name="Company" className="InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont" placeholder="PT Hotel Sentosa Ayu" id="ContactUsCompanyInputField" />
                    </div>
                    <p className="RedWarningText InterMediumTextFont RedWarningHidden" id="ContactUsCompanyWarning">Sample Warning</p>
                  </div>
                </div>
                <div className="TwoSeparatorWrapper InputFieldMargin">
                  <div className="TwoSeparatorContent">
                    <p className="InputFieldHeaderText InterMediumTextFont" id="ContactUsPhoneNumberHeaderText">Phone Number</p>
                    <div className="SmallPanelDropDownContainer BasicInputFieldContainer Selectable3" style={{width: '100%', minWidth: '100%'}} id="ContactUsPhoneNumberInputContainer">
                      <input type="text" name="PhoneNumber" className="InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont" placeholder={+62899172192} id="ContactUsPhoneNumberInputField" />
                    </div>
                    <p className="RedWarningText InterMediumTextFont RedWarningHidden" id="ContactUsPhoneNumberWarning">Sample Warning</p>
                  </div>
                  <div className="TwoSeparatorContent">
                    <p className="InputFieldHeaderText InterMediumTextFont" id="ContactUsYourEmailHeaderText">Your Email</p>
                    <div className="SmallPanelDropDownContainer BasicInputFieldContainer InputFieldWithIcon Selectable3" id="ContactUsYourEmailInputContainer" style={{width: '100%', minWidth: '100%', marginBottom: '0px'}}>
                      <img className="BasicIconInsideInput2" src="/Assets/images/ButtonIcon/mail-grey.svg" style={{marginRight: '0px'}} />
                      <input className="InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont" name="Email" type="email" placeholder="davidbayu@gmail.com" id="ContactUsYourEmailInputField" style={{outline: '0px'}} />
                    </div>
                    <p className="RedWarningText InterMediumTextFont RedWarningHidden" id="ContactUsYourEmailWarning">Sample Warning</p>
                  </div>
                </div>
                <div className="InputFieldMargin">
                  <p className="InputFieldHeaderText InterMediumTextFont" id="ContactUsYourMessageHeaderText">Your Message</p>
                  <div className="SmallPanelDropDownContainer BasicInputFieldContainer Selectable3" style={{width: '100%', minWidth: '100%'}} id="ContactUsYourMessageInputContainer">
                    <textarea className="InputFieldInsideSmallPanel ContactUsMessageInputField InputFieldSelectable InterMediumTextFont" name="Message" placeholder="Hi, Im Interest with PinginGo" rows={4} cols={50} id="ContactUsYourMessageInputField" defaultValue={""} />
                  </div>
                  <p className="RedWarningText InterMediumTextFont RedWarningHidden" id="ContactUsYourMessageWarning">Sample Warning</p>
                </div>
                <button className="BasicTextButton OrangeButton SignInButtonTop ButtonUnselectable" id="SendMessageButtonContactUs">
                  <div style={{width: 'fit-content', height: 'fit-content', display: 'flex', margin: 'auto'}}>
                    <img className="BasicIconInsideButton2 SendPaperPlaneBtnIconWhite" style={{marginLeft: 0}} />
                    <p id="SendMessageButtonTextContactUs">Send Message</p>
                  </div>
                </button>
              </div>
            </div>
            <div className="ContactUsSectionSeparator" style={{backgroundColor: '#1D76AE'}}>
              <div className="BasicContainerPadding">
                <div className="InputFieldMargin2 TopContactUsTextandImg">
                  <p className="SectionHeaderTextIndex InterMediumTextFont" style={{marginLeft: 0, width: '100%', color: 'white'}} id="ContactInformationHeaderText">Contact Information</p>
                  <img src="/Assets/images/ButtonIcon/message-icon-blue.svg" style={{opacity: 0, width: '0 !important'}} />
                </div>
                <div className="TwoAdditionalInfoContainer" style={{marginLeft: '0 !important', paddingLeft: '0 !important'}}>
                  <div className="InputFieldMargin5" style={{display: 'flex'}}>
                    <img src="/Assets/images/ButtonIcon/location-white-icon.svg" className="WarningCircleIcon" style={{marginTop: 0}} />
                    <a className="LabelGreyHeaderSmallerText2 InterRegularTextFont" href="https://maps.app.goo.gl/m5mHVqhM1nR65emk9" target="_blank" style={{color: 'white'}}>Foresta Business Loft Unit 29 - Jalan Raya Grand BSD City Cisauk Kabupaten Tangerang Selatan Banten.</a>
                  </div>
                  <div className="InputFieldMargin5" style={{display: 'flex'}}>
                    <img src="/Assets/images/ButtonIcon/phone-white-icon.svg" className="WarningCircleIcon" style={{marginTop: 0}} />
                    <a className="LabelGreyHeaderSmallerText2 InterRegularTextFont" href="tel:+628175750000" target="_blank" style={{color: 'white'}}>+628175750000</a>
                  </div>
                  <div className="InputFieldMargin2" style={{display: 'flex'}}>
                    <img src="/Assets/images/ButtonIcon/mail-icon-white.svg" className="WarningCircleIcon" style={{marginTop: 0}} />
                    <a className="LabelGreyHeaderSmallerText2 InterRegularTextFont" href="mailto:cs@pingingo.com" target="_blank" style={{color: 'white'}}>cs@pingingo.com</a>
                  </div>
                  <div className="InputFieldMargin2">
                    <button className="BasicTextButton OrangeButton SignInButtonTop Selectable" style={{margin: 0}}>
                      <div style={{width: 'fit-content', height: 'fit-content', display: 'flex', margin: 'auto'}}>
                        <a href="https://api.whatsapp.com/send?phone=628175750000" target="_blank" />
                        <img src="/Assets/images/Icon/WhatsApp.svg" className="BasicIconInsideButton" style={{marginLeft: 0}} />
                        <p id="ChatOnWhatsAppButtonText">Chat on Whatsapp</p>
                      </div>
                    </button>
                  </div>
                  <div className="InputFieldMargin2">
                    <a href="https://twitter.com/Pingin_Go" target="_blank">
                      <img src="/Assets/images/ButtonIcon/Social/x-social-media-white-icon.svg" className="SocialIconButton Selectable2" />
                    </a>
                    <a href="https://www.instagram.com/pingingo.official/" target="_blank">
                      <img src="/Assets/images/ButtonIcon/Social/ig-instagram-icon.svg" className="SocialIconButton Selectable2" />
                    </a>
                    <a href="https://www.tiktok.com/@pingingo.official" target="_blank">
                      <img src="/Assets/images/ButtonIcon/Social/tiktok-square-color-icon.svg" className="SocialIconButton Selectable2" />
                    </a>
                    <a href="https://www.facebook.com/profile.php?id=61562294233475" target="_blank">
                      <img src="/Assets/images/ButtonIcon/Social/facebook-seeklogo.svg" className="SocialIconButton Selectable2" />
                    </a>
                  </div>
                </div>
              </div>
              <img src="Assets/images/Icon/location-icon-white-inverted.svg" className="LocationBigIcon" />
            </div>
          </div>
        </div>

      </div>

      <RightPanelMobile/>

      <Footer/>
    </>
  )
}

export default ContactUs